<div class="nights-dropdown">
  <div class="nights-dropdown__list" (mouseleave)="hoverLeft.emit()">
    @for (day of days; track day) {
      <button type="button"
              class="nights-dropdown__item"
              [class.active]="isNightActive(day)"
              [class.range-start]="isNightRangeStart(day)"
              [class.range-end]="isNightRangeEnd(day)"
              [class.in-range]="isNightInRange(day)"
              (mouseenter)="hovered.emit(day)"
              (click)="selected.emit(day)">
        {{ day }}
      </button>
    }
  </div>
  <div class="nights-dropdown__hint">{{ hint }}</div>
</div>
